<app>

    <nav-bar
            user="{opts.user}"
            show-filter-bar="{false}"

    ></nav-bar>


    <section class="demo-hero-5" data-pages="parallax"
             data-pages-bg-image="/static/web/assets/images/aeroviewer-home.jpg"
             data-bg-overlay="#333" data-overlay-opacity="0.5"
    >
        <div class="container-xs-height full-height hero-gradient">
            <div class="col-xs-height col-middle text-center">
                <h1 class="text-white inner bold">
                    <b>WELCOME TO AEROVIEWER</b>
                </h1>
                <br>
            </div>
        </div>
    </section>

    <section class="bg-master-lightest p-b-60 p-t-60">
        <div class="container">
            <div class="md-p-l-20 md-p-r-20 xs-no-padding">
                <h5 class="block-title hint-text no-margin">WE AIM</h5>
                <div class="row">
                    <div class="col">
                        <h1 class="m-t-5">TO MAKE THE USE OF VISUAL CONTENT EASY AND AFFORDABLE</h1>
                    </div>
                    <div class="col no-padding xs-p-l-15 xs-p-r-15">
                        <div class="p-l-35 md-p-l-5">
                            <p>Geotag Aeroview aims to make high quality & professional visual content, (videos and
                                photos
                                of the entire Mediterranean coastline), easy to use and embed in very attractive,
                                competitive and affordable prices. It produces, distributes and delivers high definition
                                visual content taken from a helicopter. Aerial photos and videos are coupled with their
                                relative coordinates. This unique visual content is offered and delivered in a variety
                                of
                                forms and formats.</p>
                            <p class="hint-text font-arial col-md-7 no-padding">Especially for the web use this
                                content is delivered as a service and the prices are extremely low. Our vision is to
                                make
                                the visual content usage in the web as easy as it gets and as affordable it can be.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!--End Three steps section -->

    <!-- Pricing Banner -->
    <section class="p-b-50 p-t-50 bg-master-darkest" data-pages-bg-image="/static/web/assets/images/about_us.jpg"
             data-bg-overlay="#333"
             data-overlay-opacity="0.4">
        <div class="container p-b-50 p-t-50">
            <div class="row">
                <div class="col">
                    <div class="text-center">
                        <p class="h2 text-white p-b-10">We offer unique <strong>aerial videos and photos</strong>, with
                            innovative delivery and
                            presentation services at extremely low prices.</p>
                        <a id="about-pricing" class="btn btn-lg btn-primary btn-cons btn-rounded m-t-20"
                           href="/pricing"
                           style="background-color: #008cfa; border-color: #008cfa;">
                            View Prices
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-overlay" style="background-color: black; opacity: 1;"></div>
    </section>
    <!-- end Pricing Banner -->

    <!-- Section Title -->
    <section class="p-b-20 p-t-20">
        <div class="container">
            <div class="row">
                <div class="col text-center">
                    <h1 class="block-title m-b-0">CONTENT AS A SERVICE TAILORED BY YOU
                    </h1>
                </div>
            </div>
        </div>
    </section>
    <!-- End section title -->

    <section class="p-b-40 sm-p-b-0">
        <div class="container">
            <div class="col text-center">
                <p>We developed <strong>AEROVIEWER platform</strong> in order to begin a new era in the visual content
                    market and we
                    offer the customization, presentation and delivery technologies to make this content individualized
                    and cheap. Geotag Aeroview aims to make high quality & professional visual content, (videos and
                    photos of the entire Mediterranean coastline), easy to use and embed in very attractive, competitive
                    and affordable prices.</p>
            </div>
        </div>
    </section>

    <section class="p-b-50 p-t-50 bg-master-darkest sm-no-margin"
             data-pages-bg-image="/static/web/assets/images/about_banner_2.jpg"
             data-bg-overlay="black" data-overlay-opacity="0.3" data-pages="parallax"
             style="background: url(/static/web/assets/images/about_us.jpg) center 95.6618%;">
        <div class="container p-b-50 p-t-50">
            <div class="row">
                <div class="col text-center">
                    <p class="h1 text-white block-title m-b-0">AERIAL PHOTOS AND VIDEOS</p>
                    <p class="h5 text-white light p-b-10">Aerial photos and videos are coupled with their
                        relative coordinates. This unique visual content is
                        offered and delivered in a variety of forms and formats. Especially for the web, this
                        content is
                        delivered as a service and the prices are extremely low. Our vision is to make the
                        visual content
                        usage in the web as easy as it gets and as affordable it can be.</p>
                </div>
            </div>
        </div>
        <div class="bg-overlay" style="background-color: black; opacity: 0.3;"></div>
    </section>


    <!--Section Title-->
    <section class="p-b-20 p-t-20">
        <div class="container">
            <div class="row">
                <div class="col text-center">
                    <h1 class="block-title m-b-0">Compose & Present visual content</h1>
                    <h3 class="m-t-5 light">It is simple as one, two, three.</h3>
                </div>
            </div>
        </div>
    </section>
    <!--End section title-->

    <!--Three steps section-->
    <section class="p-b-85 p-t-55 p-b-65 p-t-55 bg-master-lightest">
        <div class="container">
            <div class="row md-p-l-20 xs-no-padding">
                <div class="col-sm-4 no-padding">
                    <div class="p-r-40 md-pr-30">
                        <p class="h1" style="color: #10cfbd; font-size: 3em"><b>1</b></p>
                        <h6 class="block-title p-b-5">Select / Choose<i class="pg-arrow_right m-l-10"></i></h6>
                        <p class="m-b-30">Select (capture) the video segments or choose the photos you like most. Add
                            your
                            caption, title and meta-tags-keywords to enrich the content with SEO enabling elements. To
                            find
                            the content of your choice just type the name of the area or drag the heli-Pin to the
                            desired
                            area on the Map.</p>
                    </div>
                </div>
                <div class="col-sm-4 no-padding">
                    <div class="p-r-40 md-pr-30">
                        <p class="h1" style="color: #10cfbd; font-size: 3em"><b>2</b></p>
                        <h6 class="block-title p-b-5">Compose<i class="pg-arrow_right m-l-10"></i></h6>
                        <p class="m-b-30">In step 2 you just select the video segments you like to use in your video or
                            the
                            photos to use in your slideshow. You choose (or rearrange the sequence) and if you like some
                            simple editing effect. That's it. You have created your own tailor made video or
                            slideshow.</p>
                    </div>
                </div>
                <div class="col-sm-4 no-padding">
                    <div class="p-r-40 md-pr-30">
                        <p class="h1" style="color: #10cfbd; font-size: 3em"><b>3</b></p>
                        <h6 class="block-title p-b-5">Embed or choose display format<i
                                class="pg-arrow_right m-l-10"></i>
                        </h6>
                        <p class="m-b-30">The created visual content is immediately available and
                            ready to be streamed directly from our CDN to the preferred location or page on your site.
                            The
                            widget is a click away of your site. Copy the snippet in the right place and you are done.
                            So
                            simple; as one, two, three.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>


    <section class="p-b-50 bg-master-darkest sm-no-margin"
             data-pages-bg-image="/static/web/assets/images/about_us.jpg"
             data-bg-overlay="black" data-overlay-opacity="0.3" data-pages="parallax"
             style="background: url(/static/web/assets/images/about_us.jpg) center 95.6618%;">
        <div class="container p-b-50 p-t-50">
            <div class="row">
                <div class="col">
                    <div class="col-xs-height col-middle">
                        <div class="text-center">
                            <h4 class="text-white p-b-10">We flew with a manned helicopter over the entire
                                Mediterranean coastline and captured it in hundreds of hours of HD aeria l video and
                                hundreds of thousands of ultra-high resolution aerial photos.</h4>
                            <a href="/image-select">
                                <button id="about-explore" type="button"
                                        style="background-color: #008cfa; border-color: #008cfa;"
                                        class="btn btn-lg btn-primary btn-cons btn-rounded m-t-20">Explore
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-overlay" style="background-color: black; opacity: 0.3;"></div>
    </section>
    <!-- End section title -->

    <avr-footer></avr-footer>
    <script>

        // import components

        import '../../components/nav-bar/nav-bar.tag.html';
        import '../../components/avr-footer/avr-footer.tag.html';


        // app instance
        const app = this;

    </script>
</app>


// WEBPACK FOOTER //
// avr_eshop/frontend/apps/about/app.tag.html